import script from "./invoice-detail-gt-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./invoice-detail-gt-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./invoice-detail-gt-dialog.vue?vue&type=style&index=0&id=34176f6b&lang=scss"

const __exports__ = script;

export default __exports__